import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const VisitToCosmetologist = lazyWithPreload(
  () => import('./VisitToCosmetologist'),
)
